// Reducer
import { ACTION_TYPES } from './customer.actions';
import { CustomerState, initialState } from './customer.state';

export default (state: CustomerState = initialState, action): CustomerState => {
  switch (action.type) {
    case ACTION_TYPES.UPDATE_CUSTOMER: {
      const customer = action.payload;
      customer.phoneNumber = customer.phoneNumber || '';

      return {
        ...customer
      };
    }
    default:
      return state;
  }
};
